export default __webpack_public_path__ + "media/music/c569f8efe18040579ace259d6bfe59ab.mp3";